/** Text measurement and layout using @chenglou/pretext
 * Used for precise multi-line text truncation and reading time estimation
 */

// Note: @chenglou/pretext will be imported after npm install
// import { prepare, layout } from '@chenglou/pretext'

export function initTextLayout(): void {
  // Precise excerpt truncation for article cards
  document.querySelectorAll('.post-excerpt').forEach((el) => {
    const htmlEl = el as HTMLElement
    const text = htmlEl.textContent || ''
    const maxLines = 3

    // Use CSS line-clamp as fallback until pretext is fully integrated
    htmlEl.style.display = '-webkit-box'
    htmlEl.style.webkitLineClamp = String(maxLines)
    htmlEl.style.setProperty('-webkit-box-orient', 'vertical')
    htmlEl.style.overflow = 'hidden'

    // TODO: Replace with pretext-based measurement for pixel-perfect truncation
    // const prepared = prepare(text, '16px LXGW WenKai Screen')
    // const { lineCount } = layout(prepared, htmlEl.clientWidth, 24)
  })
}
